import React, { useState, useRef } from 'react'
import 'primeicons/primeicons.css';
import { ApproveUserProfile,banUser,denyUserProfile,unbanUser, giveFreeMembership } from '../../../../../../common/_services/admin.service'
import { User, UserPhoto, UserVerifyPhoto } from '../../../../../../common/types/user'
import { useFetchV2 } from '../../../../_core/hooks'
import ProfileBox from '../../_components/profile/profileBox'
import { DataTable, DataTableExpandedRows, DataTableFilterEvent, DataTableFilterMeta, DataTablePageEvent, DataTableValueArray } from 'primereact/datatable'
import { Column,ColumnProps,ColumnFilterElementTemplateOptions } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { getUsers, LazyTableState } from '_services/users.service'
import { Button } from 'primereact/button'
import { FilterMatchMode, } from 'primereact/api'
import SidebarWrapper from '../../_components/profile/components/SidebarWrapper'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect'
import { TabPanel, TabView } from 'primereact/tabview'
import {formatDateTimeAbsolute} from '../../../../../../common/util/formatters'
import * as jt from '@js-joda/core'
import { formatHeightMeasurement } from 'util/helpers.converters';
import { Avatar } from 'primereact/avatar';
import Await from '../../../../_core/components/await';
import { getProductsSubscriptions, productTypes } from '_services/iap.service'
import { EnumProductsData } from 'types/enums.options';
import MenuButton from '../../../../components/menu-button'
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { PopupContext, PopUpContextType} from '../../../../_core/contexts/popToast'
import StatusBadges from './components/status-badges';
import MergeUsersdialog from './components/mergeUsers-dialog';

export type PhotoWithName = (UserPhoto | UserVerifyPhoto & {firstName:string, lastName:string})

interface status {
  display:string,
  severity:"success" | "danger" | "info" | "warning" | null | undefined
}

let filterDebounce: number | null = null

const SystemScreen: React.FC = () => {

  const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined)
  const [selectedUsers, setSelectedUsers] = useState<User[]>([])
  const [viewUser, setViewUser] = useState<string>('')
  const [globalFilterValue, setGlobalFilterValue] = useState<string>('')

  const [giftDialogVisible, setGiftDialogVisible] = useState(false)
  const [mergeDialogVisible, setMergeDialogVisible] = useState(false)
  const selectedProduct = useRef<EnumProductsData | null>(null)
  const giftRecipient = useRef<User | null>(null)
  const mergePrimaryUser = useRef<User | null>(null)
  const { openPopup } = React.useContext<PopUpContextType>(PopupContext)

  const [lazyState, setlazyState] = useState<LazyTableState<DataTableFilterMeta>>({
    first             : 0,
    rows              : 10,
    page              : 0,
    filters: {
      globalFilter            : { value: '', matchMode: FilterMatchMode.CONTAINS },
      firstName               : { value: '', matchMode: FilterMatchMode.CONTAINS },
      lastName                : { value: '', matchMode: FilterMatchMode.CONTAINS },
      phone                   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      email                   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      occupationName          : { value: '', matchMode: FilterMatchMode.CONTAINS },
      aboutMe                 : { value: '', matchMode: FilterMatchMode.CONTAINS },
      highestEducationLevel   : { value: '', matchMode: FilterMatchMode.CONTAINS },
      status                  : { value: [], matchMode: FilterMatchMode.CUSTOM  },
    }
  })

  const [products] = useFetchV2(
    () => getProductsSubscriptions(productTypes.Gift),
    undefined,
    []
  )

  const [users, fetchUsers] = useFetchV2(
    () => getUsers<DataTableFilterMeta>(lazyState),
    undefined,
    [lazyState]
  )

  const [statuses] = useState<status[]>([
    {display:'User Approved', severity: 'success'},
    {display:'Pending User Review', severity: 'danger'},
    {display:'Pending Photo Approval', severity: 'danger'},
    {display:'Photos Approved', severity: 'success'},
    {display:'Verified', severity: 'success'},
    {display:'Pending Verify', severity: 'danger'},
    {display:'Premium', severity: 'info'},
    {display:'Banned', severity: 'danger'},
    {display:'Denied User Approval', severity: 'danger'},
  ])

  const _FormatDate = (date: string) => {
    const instantProcessed = date ? formatDateTimeAbsolute(jt.Instant.parse(date)) : null
    return instantProcessed;
  }

  const multiFilterOption = (options: ColumnFilterElementTemplateOptions) => {
    return (
      <MultiSelect
        id="status"
        name="status"
        display="chip"
        value={options.value}
        options={statuses}
        onChange={(e: MultiSelectChangeEvent) => options.filterApplyCallback(e.value)}
        optionLabel="display"
        optionValue="display"
        placeholder="Any"
        className="p-column-filter"
        maxSelectedLabels={1}
        style={{ minWidth: '10rem' }}
      />
    )
  }
  const columns: ColumnProps[] = [
    {
      field: '',
      header: 'Profile Photo',

      body: (data: User) =>
        <>
          <Avatar onClick={() => {setViewUser(data.id)}}
                  image={data.userPhotos && data.userPhotos[0]?.imgUrl}
                  size="xlarge"
                  icon="pi pi-user"
                   />
        </>
    },
      {
        field: 'firstName',
        header: 'First Name',
        filter: true,
        filterPlaceholder: "First Name",
      },
      {
        field: 'lastName',
        header: 'Last Name',
        filter: true,
        filterPlaceholder: "Last Name",
      },
      {
        field: 'userMetadata.birthday',
        header: 'Date of Birth',
        filter: false,
        dataType: 'date',
        filterPlaceholder: "Birthday search",
      },
      {
        field: 'userGender',
        header: 'Gender',
        filter: false,
        filterPlaceholder: "Gender search",
        body:(data:User) => <>{data.userMetadata?.UserGender?.display}</>
      },
      {
        field: 'phone',
        header: 'Phone #',
        filter: true,
        filterPlaceholder: "Phone #",
        style: { width: '8rem' },
        body:(data: User) => <>{data.countryCode}+ {data.phone}</>
      },
      {
        field: 'email',
        header: 'Email',
        filter: true,
        filterPlaceholder: "Email",
      },
      {
        field: 'source',
        header: 'Source',
        filter: false,
        filterPlaceholder: "Source",
        body:(data:User) => <>{!!data.dbgId && !!data.phone ? 'DBG+DAtP' : !!data.dbgId ? 'DBG' : 'DAtP'}</>,
      },
      {
        field: 'lastLoggedIn',
        header: 'Last Login',
        filter: false,
        filterPlaceholder: "Last Login",
        body:(data:User) => !!data.lastLoggedIn ? <>{formatDateTimeAbsolute(jt.Instant.parse(data.lastLoggedIn))}</> : <>&mdash;</>,
      },
      {
        field: 'occupationName',
        header: 'Occupation',
        filter: true,
        filterPlaceholder: "Occupation search",
        body:(data:User) => <>{data.userMetadata?.occupationName}</>
      },
      {
        field: 'userMetadata.aboutMe',
        header: 'About Me',
        style: { width: '15rem' },
        filter: false,
        filterPlaceholder: "About me search",
      },
      {
        field: 'highestEducationLevel',
        header: 'Highest Education',
        filter: true,
        filterPlaceholder: "Highest Education Search",
        body:(data:User) => <>{data.userMetadata?.highestEducationLevel}</>
      },
      {
        field: 'nationalities',
        header: 'Nationalities',
        filter: false,
        filterPlaceholder: "Nationalities Search",
        body:(data:User) => <>{data.userMetadata?.Nationalities?.map(x => x.EnumNationality.nationality).join(', ')}</>
      },
      {
        field: 'userMetadata.heightMeasurement',
        header: 'Height',
        filter: false,
        filterPlaceholder: "Height Search",
        body: (data:User) => <>
          {data.userMetadata?.heightMeasurement && formatHeightMeasurement(data.userMetadata?.heightMeasurement).dualLocaleDisplay}
        </>
      },
      {
        columnKey: 'status',
        field: 'status',
        header: 'Status',
        filter: true,
        style: { width: '1rem' },

        filterPlaceholder: "Status search",
        filterMatchMode:"custom_status",
        filterElement: multiFilterOption,
        body:(data: User) => <>{<StatusBadges data={data}/>}</>
      },
  ]

  const menuItems = (user: User) => [
    {
      'label': 'Options',
      'items': [
        {visible:(user.isBanned), label:"Unban",
          command:() => {unbanUser([user.id],fetchUsers)}
        },
        {visible:(!user.isBanned), label:"Ban",
          command:() => {banUser([user.id],fetchUsers)}
        },
        {visible:(!user.deniedAt), label:"Deny",
          command:() => {denyUserProfile([user.id],fetchUsers)}
        },
        {visible:(!user.approvedAt), label:"Approve",
          command:() => {ApproveUserProfile([user.id],fetchUsers)}
        },
        {label:"Gift Premium",
          command:() => {openGiftDialog(user)}
        },
        {label:"Merge Users",
          command:() => {openMergeDialog(user)}
        }
      ]
    }
  ]

  const onPage = (event: DataTablePageEvent) => {
    setlazyState((prev) => ({...prev,...event}))
  }

  const onFilter = (event: DataTableFilterEvent) => {
    event['first'] = 0
    event['page'] = 0
    setlazyState((prev => ({...prev,'filters':{...prev.filters,...event.filters}})))
  }

  const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(event.target.value)
    if(filterDebounce){
      window.clearTimeout(filterDebounce)
    }
    filterDebounce = window.setTimeout(() => {
    onFilter({filters: {'globalFilter': {value: event.target.value, matchMode: FilterMatchMode.CONTAINS}}})
    }, 1000)
  }

  const openGiftDialog = (user:User) => {
    giftRecipient.current = user
    setGiftDialogVisible(true)
  }

  const closeGiftDialog = () => {
    setGiftDialogVisible(false)
  }

  const openMergeDialog = (user:User) => {
    mergePrimaryUser.current = user
    setMergeDialogVisible(true)
  }

  const closeMergeDialog = () => {
    setMergeDialogVisible(false)
    fetchUsers(undefined)
  }

  const onSuccess = () => {
    openPopup({
      severity: 'success', title: 'Gift Successful!',
      text: `You have gifted ${selectedProduct.current?.name} to ${giftRecipient.current?.firstName} ${giftRecipient.current?.lastName}.`, duration: 3000
    })
    fetchUsers(undefined)
  }

  const accept = () => {
    giveFreeMembership(giftRecipient.current!.id, selectedProduct.current!.id,
      onSuccess,
      (e) => openPopup({ severity: 'warn', title: 'Rejected', text: `Error: ${e}`, duration: 3000 })
    )
    setGiftDialogVisible(false)
  }

  const reject = () => {

  }

  const giftConfirmDialog = (product: EnumProductsData) => {
    selectedProduct.current = product
    confirmDialog({
        message: `Are you sure you wish to give ${selectedProduct.current.name} to ${giftRecipient.current?.firstName}`,
        header: 'Gift confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept,
        reject
    })
  }

  const UserDatatable = (props:{data:{users:User[],total:number} | undefined}) => {
    return <>
      <DataTable
        stripedRows
        lazy
        onPage={onPage}
        onFilter={onFilter}
        first={lazyState.first}
        filters={lazyState.filters}
        totalRecords={props.data ? props.data.total : 0}
        filterDisplay="menu"
        paginator
        rows={lazyState.rows}
        rowsPerPageOptions={[5, 10, 25, 50]}
        value={props.data ? props.data.users : []}
        loading={!props.data}
        tableStyle={{ minWidth: 'min-content' }}
        expandedRows={expandedRows}
        selection={selectedUsers}
        selectionMode="multiple"
        onSelectionChange={(e) => setSelectedUsers(e.value)}
        onRowToggle={(e) => {setExpandedRows(e.data)}}
        size="small"
      >
        <Column selectionMode="multiple" headerStyle={{ width: '2rem' }}></Column>
        {columns.map((x) => <Column
          key={x.field}
          {...x}
          />
        )}
        <Column field="id"
          style={{ width: '5rem' }}
          body={(y: User) =>
            <div>
            <MenuButton
                    className="rounded-circle p-1"
                    items={menuItems(y)}
                    menuProps={{
                      'popup':true,
                      'popupAlignment':'left',
                    }}
            ></MenuButton>
            </div>
            }
        ></Column>
      </DataTable>
    </>
  }

  const GiftDialog = (props:{products:EnumProductsData[] | undefined}) => {
    return <>
    <Dialog header={`Gift options for ${giftRecipient.current?.firstName ?? "Member"}`}
            visible={giftDialogVisible}
            style={{width: "30vw"}}
            onHide={closeGiftDialog}
            >
            {props.products && props.products.map((product) =>
            <Card style={{backgroundColor:"#f5f5f5"}} className={"m-2"} title={product.name}>
              <div style={{display: 'flex'}}>
                <p className="m-0">
                  {product.description}
                </p>
                <Button style={{marginLeft: 'auto'}} className="pi" label="Select" onClick={() => {giftConfirmDialog(product)}} />
              </div>
            </Card>)}
          </Dialog>
    </>
  }

  return <div className="m-4 justify-content-center h-100">
      <ConfirmDialog />
      <SidebarWrapper
        position="right"
        className="w-full md:w-40rem lg:w-40rem"
        visible={!!viewUser}
        onHide={() => setViewUser('')}
        style={{width:'45%'}}
      >
       {
          viewUser != '' && <ProfileBox
            userId={viewUser}
          />
        }
      </SidebarWrapper>
      <TabView>
        <TabPanel header="Users">
        <div className="d-flex">
            <div className="p-2 bd-highlight">
              <h3>Users</h3>
            </div>
            <div className="ms-auto p-2 bd-highligh">
              <IconField iconPosition="left">
                  <InputIcon className="pi pi-search" />
                  <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search"/>
              </IconField>
            </div>
          </div>
          <Await dependency={users} fallback={<UserDatatable key="DATATABLE" data={undefined}></UserDatatable>}>{(data) =>
            <UserDatatable key="DATATABLE" data={data}/>
          }</Await>
          <Await dependency={products}>{(x) =>
            <GiftDialog products={x}/>
          }</Await>
          <MergeUsersdialog primaryUser={mergePrimaryUser.current!} isVisible={mergeDialogVisible} onHide={closeMergeDialog}/>
        </TabPanel>
      </TabView>
   </div>
}

export default SystemScreen
